export default "__VITE_ASSET__C4JHtJFe__"